import React from "react"
import { Col, Input, Modal, ModalBody, Row } from "reactstrap"
import PrimaryButton from "../../../../../components/common/PrimaryButton/PrimaryButton"

function EasyPaisaAndJazzCashModal({ isOpen, setIsOpen }) {
  const toggle = () => setIsOpen(!isOpen)

  return (
    <div>
      <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
        <ModalBody>
          <div className="fw-semibold fs-4 text-center">Easypaisa/Jazzcash</div>

          <Row className="mt-3">
            <Col>
              <label htmlFor="bankName" style={{ fontWeight: 500, fontSize: '0.8125rem' }}>Account type</label>
              <Input placeholder="Account type" id="bankName" />
            </Col>
            <Col>
              <label htmlFor="accHolderName" style={{ fontWeight: 500, fontSize: '0.8125rem' }}>Account holder name</label>
              <Input placeholder="Account holder name" id="accHolderName" />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <label htmlFor="mobileNumber" style={{ fontWeight: 500, fontSize: '0.8125rem' }}>Mobile number</label>
              <Input placeholder="Mobile number" id="mobileNumber" />
            </Col>
            <Col>
              <label htmlFor="accountPin" style={{ fontWeight: 500, fontSize: '0.8125rem' }}>Account Pin</label>
              <Input placeholder="Account Pin" id="accountPin" />
            </Col>
          </Row>

          <div className="d-flex justify-content-end mt-3">
            <PrimaryButton name={'Add Account'} />
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default EasyPaisaAndJazzCashModal
